export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6922.b6d22dfd.jpg";